import React, { useState } from 'react'
import SweetAlert from "react-bootstrap-sweetalert";
import { Row, Col, Card, CardBody, Button, Label, FormGroup } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { addLinkHomeSessionsApi } from '../../../Constants/api';
import { useHistory, useParams } from "react-router-dom";

const EditHomeSessions = () => {


  const { userId } = useParams();
  const history = useHistory();
  const [appointmentJoiningLink, setAppointmentJoiningLink] = useState("");
  const [showUnPublishAlert, setShowUnPublishAlert] = useState(false);
  const [showUnPublishConfirm, setShowUnPublishConfirm] = useState(false);

  const queryParameters = new URLSearchParams(window.location.search);
  const sessionId = queryParameters.get("sessionId");

  const addMeetinLinkNutriClassData = async () => {
    try {
      setShowUnPublishAlert(true);
      await addLinkHomeSessionsApi(userId, {
        appointmentJoiningLink: appointmentJoiningLink,
      });

      setShowUnPublishAlert(false);
      setShowUnPublishConfirm(true);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h3 className="m-0">Add Meeting Link </h3>
                  </div>
                </Col>
              </Row>
              <AvForm
                className="form-horizontal"
                onValidSubmit={() => setShowUnPublishAlert(true)}
              >
                <Row>
                  <Col>
                    <FormGroup>
                      <Label htmlFor="appointmentJoiningLink">Meeting Link</Label>
                      <AvField
                        name="appointmentJoiningLink"
                        placeholder="Enter meeting link"
                        value={appointmentJoiningLink}
                        onChange={(e) => setAppointmentJoiningLink(e.target.value)}
                        type="text"
                        errorMessage="Meeting Link is required"
                        className="form-control"
                        validate={{ required: { value: true } }}
                        id="title"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Button
                  color="primary"
                  className="w-100 mt-4"
                  type="submit"
                  disabled={false}
                >
                  Add Meeting Link
                </Button>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {showUnPublishAlert ? (
        <SweetAlert
          title="Are you sure?"
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText="Yes, Add Meeting Link"
          reverseButtons={true}
          onConfirm={() => {
            addMeetinLinkNutriClassData();
            setShowUnPublishAlert(false);
          }}
          onCancel={() => setShowUnPublishAlert(false)}
        ></SweetAlert>
      ) : null}

      {showUnPublishConfirm ? (
        <SweetAlert
          success
          title="Added!"
          confirmBtnBsStyle="primary"
          onConfirm={() => {
            setShowUnPublishAlert();
            setShowUnPublishConfirm();
            history.push(
              `${"/dashboard/n-live/booking-sessions/all-booking-sessions-user/" + sessionId}`
            );
          }}
        >
          Meeting Link has been added for Nutri Diet Class
        </SweetAlert>
      ) : null}
    </>
  );
}

export default EditHomeSessions